import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {TasksModel} from '../../../tasks/models/tasks.model';

class CustomFeedbackAnswersModel {
    id: number;
    // tslint:disable-next-line:variable-name
    section_id: number;
    title: string;
    order: number;
}

class CustomFeedbackModel {
    // tslint:disable-next-line:variable-name
    section_id: number;
    // tslint:disable-next-line:variable-name
    del_id: number;
    answers: { question: CustomFeedbackAnswersModel, value: number }[];
}

@Component({
    selector: 'app-journey-list-template-feedback-list',
    templateUrl: './list-template-feedback-list.component.html',
    styleUrls: ['./list-template-feedback-list.component.scss']
})
export class LearningJourneyListTemplateFeedbackListComponent implements OnInit {

    details: CustomFeedbackModel = null;
    title: string = null;
    description: string = null;

    @Input() disabled = false;
    @Input() for_manager = false;
    @Input() embedded = false;
    @Input() task: TasksModel = null;
    @Output() doChange: EventEmitter<any> = new EventEmitter();

    radioGroup = [
        {text: '1', value: '1', class: ''},
        {text: '2', value: '2', class: ''},
        {text: '3', value: '3', class: ''},
        {text: '4', value: '4', class: ''},
        {text: '5', value: '5', class: ''}
    ];

    highlight = '0';
    min = 1;
    max = 5;

    constructor() {
    }

    ngOnInit() {
        if (this.task.url.startsWith('default') && this.task.url.split('-').length === 3) {
            const [_, min, max] = this.task.url.split('-');
            this.min = +min;
            this.max = +max;

            if (this.min < 1) {
                this.highlight = (this.min - 1).toString();
            }

            this.radioGroup = Array.from({length: this.max - this.min + 1}, (_, i) => {
                return {text: (this.min + i).toString(), value: (this.min + i).toString(), class: ''};
            })
        }
    }

    onChange(event) {
        setTimeout(()=>{
            const num_unanwered = this.task.details.custom_feedback.answers.reduce((acc, item) =>  acc + (!item.value ? 1 : 0), 0);
            if (!num_unanwered) {
                this.task.status = true;
                this.task.click = true;
            }
            this.doChange.emit(this.task.details.custom_feedback);
        }, 0)
    }

}
